"use strict";

var breakpoints = [40, 52, 64];

var space = [0, 8, 16, 32, 64];

var fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72];

module.exports = {
  breakpoints: breakpoints,
  space: space,
  fontSizes: fontSizes
};


//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/~/styled-system/dist/constants.js
// module id = 23
// module chunks = 35783957827783 64691314399603 114276838955818 228131777832141